import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { SelectItem } from 'primeng/api';
import { AbstractControl } from '@angular/forms';
import { FiskalniRacuniClient } from '@kodit/core/data-api';

@Component({
  selector: 'kodit-post-akcija-fiskalizacija-dropdown',
  templateUrl: './post-akcija-fiskalizacija-dropdown.component.html',
  styleUrls: ['./post-akcija-fiskalizacija-dropdown.component.scss']
})
export class PostAkcijaFiskalizacijaDropdownComponent implements OnInit, OnDestroy {

  private _subs: Subscription = new Subscription();

  /** Props */
  items: SelectItem[] = [];

  @Input() formCtrl: AbstractControl;
  @Input() formCtrlId: string;
  @Input() parentCtrl: any = 'body';

  constructor(private _client: FiskalniRacuniClient) { }

  ngOnInit(): void {
    this._load();
  }

  private _load() {
    this._subs.add(
      this._client.getTipPostFiskalizacija().subscribe((res) => {
        this.items = res.data.postFiskalizacijaAkcijaDtoList.map((x) => ({
          value: x.postFiskalizacijeAkcija,
          label: x.postFiskalizacijeAkcijaStr,
          title: x.opis,
        }));
      })
    );
  }
  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }

}
